'use client';

import { Button, ButtonGroup, PageHeader, TextLink } from '@petsmart-ui/sparky';

import { NAVIGATION_URLS } from '@libs/core';

import { PICTURES, SUPPORT_PHONE_NUMBER } from '../../constants';
import { ResponsivePicture } from '../ResponsivePicture';

import './ErrorNotFound.scss';

const className = 'error-not-found';

export const TermsNote = () => {
    return (
        <div className="terms-note">
            *Terms apply. Pricing, promotions and availability may vary by
            location and at PetSmart.com.
        </div>
    );
};

export default function ErrorNotFound() {
    const description = (
        <div
            className="sparky-u-theme-typography-body-lg-bold sparky-u-theme-typography-heading-6"
            data-testid="error-not-found"
        >
            <div>Error 404.</div>
            <div className={`${className}__text`}>
                Even our best sniffers can’t find your page. Want help? Contact
                us at{' '}
                <TextLink
                    bold
                    href={`tel:${SUPPORT_PHONE_NUMBER.RAW}`}
                    className="sparky-u-theme-typography-heading-6"
                >
                    {SUPPORT_PHONE_NUMBER.FORMATTED}
                </TextLink>
                .
            </div>
        </div>
    );

    return (
        <div className={`sparky-u-responsive-margin-top-32-32-64 ${className}`}>
            <PageHeader
                align="center"
                title="Oops!"
                description={description}
                className={`${className}__header`}
            />
            <ResponsivePicture
                data-testid="404-picture"
                src={PICTURES.NOT_FOUND.SRC}
                alt={PICTURES.NOT_FOUND.ALT_TEXT}
                className={`${className}__picture`}
                priority="eager"
                sizes={[
                    { width: 250, height: 250 },
                    { width: 350, height: 350 },
                    { width: 400, height: 400 },
                ]}
            />
            <ButtonGroup align="center" className="sparky-u-margin-top-md">
                <Button
                    className={`sparky-u-theme-typography-body-lg ${className}__button`}
                    variant="primary"
                    text="Continue Shopping"
                    data-testid="404-button"
                    href={NAVIGATION_URLS.legacy.base}
                />
            </ButtonGroup>
            <TermsNote />
        </div>
    );
}
